import { useState, useEffect } from 'react';

import useRouter from 'utils/useRouter';
import { get, isNil, size } from 'lodash';
import { useDispatch } from 'react-redux';
import { useUnmount, useMount } from 'react-use';

import { handleWaitingCount } from '@state/actions';
import { sessionsRefetched } from 'state/actions';
import { initializeEcho } from '@services/echo';
import { STATES } from '@constants/SESSION';
import { Sessions } from '@services/http';
import useHttp from '@hooks/useHttp';

const useWaitingRoom = () => {
  const [echo, setEcho] = useState(null);
  const dispatch = useDispatch();
  const router = useRouter();

  const sessions = useHttp({
    endpoint: () =>
      Sessions.getAll({
        configuration: {
          params: {
            'filter[state]': STATES.WAITING_ROOM,
          },
        },
      }),
  });

  useMount(() => {
    console.log('useMount navigation list item');
    const channel = 'sessions-in-waiting-room';
    let Echo;
    if (isNil(echo)) {
      try {
        Echo = initializeEcho();
        if (!isNil(Echo)) {
          setEcho(Echo);
          Echo.channel(channel).listen('SessionsInWaitingRoom', () => {
            console.info('SessionsInWaitingRoom event, navigation list item');
            sessions.reFetch();
            dispatch(sessionsRefetched());
          });
          return;
        }
      } catch (err) {
        console.error(err);
        router.history.push('/auth/login');
      }
    }
  });

  useUnmount(() => {
    console.log('useUnmount navigation list item');
    const channel = 'sessions-in-waiting-room';
    if (!isNil(echo)) {
      console.info('leaving echo channel navigations list item', channel);
      echo.leave(channel);
    }
    return;
  });

  useEffect(() => {
    const length = size(get(sessions, 'value.data'));

    dispatch(handleWaitingCount(length));
  }, [dispatch, sessions]);
};

export default useWaitingRoom;
